import { Box, Tab, Tabs, makeStyles } from '@material-ui/core';
import { Route, Switch } from 'react-router-dom';
import { Typography, useRouter, useTheme } from '../..';
import { matchPath } from 'react-router';
import React, { Fragment } from 'react';
import snakeCase from 'lodash/snakeCase';
import zip from 'lodash/zip';
const useStyles = makeStyles(({ palette, spacing, typography }) => ({
    selected: {
        color: `${palette.secondary.main} !important`,
        fontWeight: typography.fontWeightMedium,
        borderBottomColor: palette.secondary.main,
    },
    root: {
        color: palette.text.secondary,
        fontWeight: typography.fontWeightLight,
        textTransform: 'capitalize',
        '&:hover': {
            backgroundColor: palette.background.default,
        },
    },
}));
export const RouterTabContent = ({ label, children }) => {
    return React.createElement(Box, { p: 3 }, children);
};
export const RouterTabs = ({ children }) => {
    const theme = useTheme();
    const { history, location, match } = useRouter();
    const classes = useStyles();
    const childrenArray = React.Children.toArray(children);
    const labels = childrenArray.map(child => {
        const childProps = child.props;
        if (!childProps.label) {
            throw new Error("All children of RouterTabs must have a 'label' property");
        }
        else {
            return childProps.label;
        }
    });
    const basePath = match.path;
    const baseUrl = match.url;
    const tabMatchPath = `${basePath}/:tab`;
    const matchData = matchPath(location.pathname, {
        path: tabMatchPath,
        exact: false,
        strict: false,
    });
    const handleChange = (event, newValue) => {
        const labelAtValue = snakeCase(labels[newValue]);
        history.replace(baseUrl + `/${labelAtValue}`);
    };
    const currentTabString = matchData && matchData.params && matchData.params.tab;
    const value = labels.findIndex(label => snakeCase(label) === currentTabString);
    const childrenZippedWithLabels = zip(labels, childrenArray);
    const firstChildLabel = !!childrenZippedWithLabels.length && React.createElement(Route, null, childrenZippedWithLabels[0][1]);
    return (React.createElement(Fragment, null,
        React.createElement(Box, { pl: 3, borderBottom: `1px solid ${theme.palette.divider}` },
            React.createElement(Tabs, { value: value !== -1 ? value : 0, onChange: handleChange, "aria-label": "simple tabs example" }, labels.map(label => (React.createElement(Tab, { classes: classes, label: React.createElement(Typography, { variant: "subtitle2" }, label), key: label }))))),
        React.createElement(Switch, null,
            childrenZippedWithLabels.map(elem => {
                const [label, child] = elem;
                return (React.createElement(Route, { path: basePath + `/${snakeCase(label)}`, key: label }, child));
            }),
            firstChildLabel)));
};
//# sourceMappingURL=RouterTabs.js.map